import { useTheme } from '@emotion/react';
import { Tooltip } from '@mui/material';
import useLayoutTypeContext from 'framework/base/hooks/useLayoutTypeContext';
import React from 'react';
import AryIconButton from '../AryIconButton';

export default function SwitchableChip({
  title,
  handleClick,
  disabled,
  value,
  Icon
}) {
  const theme = useTheme();
  const layoutType = useLayoutTypeContext();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const form = e.target.closest('form');
      if (form) {
        form.requestSubmit();
      }
    }
  };

  return (
    <Tooltip
      title={title}
      placement="bottom"
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: theme.text.grey800.color,
            borderRadius: '4px',
            '& .MuiTooltip-arrow': {
              color: theme.text.grey800.color
            }
          }
        }
      }}
    >
      <AryIconButton
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        borderColor={
          disabled
            ? theme.icon.grey200.color
            : value
            ? theme.chip.blue.text
            : theme.icon.grey200.color
        }
        focusStyles={{
          borderColor: value
            ? theme.sidebar.active.blueBg.background
            : '#7A90AA',
          boxShadow: value
            ? '0px 2px 3px 1px #051C3126, 0px 2px 2px 0px #051C314D'
            : '0px 2px 3px 1px #051C3126,0px 2px 4px 0px #051C314D',
          background: value ? '#AFD4E9' : theme.icon.grey50.color,
          icon: value ? theme.sidebar.blueBackground : theme.text.grey300.color
        }}
        sx={{
          width: layoutType === 'mobile' ? '3rem' : '2rem',
          height: layoutType === 'mobile' ? '3rem' : '2rem',
          bgcolor: value
            ? disabled
              ? theme.icon.grey50.color
              : theme.select.selectedOption.backgroundColor
            : theme.palette.background.paper,
          '&:hover': {
            boxShadow: value
              ? '0px 1px 2px 0px #051C3114, 0px 1px 3px 0px #051C3126'
              : '0px 1px 2px 0px #051C3114, 0px 1px 3px 0px #051C3126',
            bgcolor: value
              ? theme.chip.primary.background
              : theme.wrapper.blueBackground.color
          }
        }}
        Icon={Icon}
        iconColor={
          value ? theme.sidebar.blueBackground : theme.palette.lightGrey.main
        }
        disabledIconColor={theme.text.grey300.color}
      />
    </Tooltip>
  );
}
